/* Cadar Atelier — core behaviour. No dependencies. */
(function () {
  'use strict';

  var STRINGS = readJSON('ThemeStrings') || {};
  var CONFIG = readJSON('ThemeConfig') || {};
  var ROUTES = CONFIG.routes || {};

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function announce(message) {
    var region = document.getElementById('LiveRegion');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 60);
  }

  function formatMoney(cents) {
    var format = CONFIG.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var amountNoDecimals = parts[0];
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ''))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amount.replace(/,/g, ' '))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, amountNoDecimals.replace(/,/g, ' '));
  }
  window.themeFormatMoney = formatMoney;

  /* ------------------------------------------------------------------ *
   * Drawers
   * ------------------------------------------------------------------ */
  var lastFocused = null;

  function focusables(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.getClientRects().length > 0; });
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var items = focusables(drawer);
    if (items.length) items[0].focus();
    drawer.addEventListener('keydown', trapFocus);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.removeEventListener('keydown', trapFocus);
    window.setTimeout(function () { drawer.hidden = true; }, 240);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function trapFocus(event) {
    if (event.key === 'Escape') { closeDrawer(event.currentTarget); return; }
    if (event.key !== 'Tab') return;
    var items = focusables(event.currentTarget);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) { event.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) { event.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); }
  });

  /* ------------------------------------------------------------------ *
   * Cart
   * ------------------------------------------------------------------ */
  function refreshCart() {
    return fetch(ROUTES.cart + '?section_id=cart-refresh', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-refresh]');
          var bodies = document.querySelectorAll('[data-cart-drawer-body], [data-cart-main]');
          if (fresh) {
            bodies.forEach(function (body) { body.innerHTML = fresh.innerHTML; });
          }
        }
        return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () { return null; });
  }
  window.themeRefreshCart = refreshCart;

  function addToCart(body, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.dataset.originalLabel = button.textContent; }
    return fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && result.data.description) || STRINGS.cartError;
          showFormError(button, message);
          announce(message);
          return null;
        }
        return refreshCart().then(function () {
          announce(STRINGS.addedToCart || '');
          if (CONFIG.cartType === 'drawer') openDrawer('CartDrawer');
          reportAddToCart(result.data);
          return result.data;
        });
      })
      .catch(function () { showFormError(button, STRINGS.cartError); return null; })
      .finally(function () { if (button) button.removeAttribute('aria-disabled'); });
  }
  window.themeAddToCart = addToCart;

  /* ---- ChatGPT Ads: add to cart ----------------------------------------
     Sumele se trimit in unitati minore (penny), exact cum le da Shopify in
     final_line_price. Daca pixelul nu e configurat, functia nu face nimic. */
  function reportAddToCart(data) {
    var cfg = window.OAI_ADS;
    if (!cfg || !cfg.pixelId || !cfg.trackAddToCart) return;
    if (typeof window.oaiq !== 'function') return;
    if (!data) return;

    var items = data.items || (data.id ? [data] : []);
    if (!items.length) return;

    var amount = 0;
    var contents = items.map(function (item) {
      amount += item.final_line_price || item.line_price || 0;
      return {
        id: String(item.sku || item.variant_id || item.id || ''),
        name: item.product_title || item.title || '',
        quantity: item.quantity || 1
      };
    });

    try {
      window.oaiq('measureSingle', cfg.pixelId, 'items_added', {
        type: 'contents',
        amount: amount,
        currency: cfg.currency || 'GBP',
        contents: contents
      });
    } catch (e) { /* masurarea nu are voie sa strice adaugarea in cos */ }
  }



  function showFormError(button, message) {
    if (!button || !message) return;
    var form = button.closest('form') || button.parentElement;
    if (!form) return;
    var holder = form.querySelector('[data-form-error]');
    if (!holder) {
      holder = document.createElement('p');
      holder.className = 'product-form__error';
      holder.setAttribute('data-form-error', '');
      holder.setAttribute('role', 'alert');
      form.appendChild(holder);
    }
    holder.textContent = message;
  }


  /* ---- Name embroidery -------------------------------------------------- */
  var MONOGRAM_KEY = 'Embroidered name';

  /* Se brodeaza cu acul, deci acceptam doar ce se poate coase: litere,
     spatiu, apostrof si cratima. Restul se taie, nu se respinge, ca sa nu
     se blocheze clientul in mijlocul tastarii. */
  function cleanMonogram(value, input) {
    var max = 20;
    if (input && input.getAttribute('data-monogram-max')) {
      max = parseInt(input.getAttribute('data-monogram-max'), 10) || 20;
    }
    return (value || '')
      .replace(/[^\p{L} '-]/gu, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-monogram-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-monogram]');
    if (!root) return;
    var panel = root.querySelector('[data-monogram-panel]');
    if (!panel) return;
    panel.hidden = !toggle.checked;
    if (toggle.checked) {
      var input = root.querySelector('[data-monogram-input]');
      if (input) input.focus();
    }
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-monogram-input]');
    if (!input) return;
    var root = input.closest('[data-monogram]');
    if (!root) return;
    var cleaned = cleanMonogram(input.value, input);
    if (cleaned !== input.value) input.value = cleaned;
    var preview = root.querySelector('[data-monogram-preview]');
    var count = root.querySelector('[data-monogram-count]');
    if (preview) preview.textContent = cleaned || (input.getAttribute('placeholder') || '');
    if (count) count.textContent = String(cleaned.length);
  });


  /* ChatGPT Ads: vizualizare produs. measureSingle, nu measure — contul are
     un pixel separat pentru Romania si evenimentul UK nu are ce cauta acolo. */
  (function reportProductView() {
    var cfg = window.OAI_ADS;
    if (!cfg || !cfg.pixelId) return;
    var body = document.body;
    if (!body || !body.classList.contains('template-product')) return;
    var node = document.querySelector('[data-oai-product]');
    if (!node) return;
    var price = parseInt(node.getAttribute('data-oai-price') || '0', 10);
    var sku = node.getAttribute('data-oai-sku') || '';
    var title = node.getAttribute('data-oai-title') || '';
    function fire() {
      try {
        window.oaiq('measureSingle', cfg.pixelId, 'contents_viewed', {
          type: 'contents',
          amount: price,
          currency: cfg.currency || 'GBP',
          contents: [{ id: sku, name: title, quantity: 1 }]
        });
      } catch (e) { /* masurarea nu strica pagina */ }
    }
    if (typeof window.oaiq === 'function') fire();
  })();

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-add-form]');
    if (!form) return;
    event.preventDefault();
    var data = new FormData(form);

    /* Formularele de bundle trimit items[0][id], items[1][id]... nu un singur
       camp "id". Fara ramura asta, data.get('id') era null si Shopify
       respingea cererea cu "Something went wrong". */
    var lines = {};
    data.forEach(function (value, key) {
      var m = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (!m) return;
      lines[m[1]] = lines[m[1]] || {};
      lines[m[1]][m[2]] = value;
    });
    var indices = Object.keys(lines);
    if (indices.length) {
      var items = indices
        .sort(function (a, b) { return a - b; })
        .map(function (i) { return { id: lines[i].id, quantity: parseInt(lines[i].quantity || '1', 10) }; })
        .filter(function (item) { return item.id; });
      if (!items.length) return;
      /* Bundle-ul afiseaza un pret redus, deci reducerea trebuie sa existe
         cu adevarat in cos. Codul e restrictionat la perne si protectii,
         iar /discount/<cod>?redirect=/cart il aplica si duce clientul in cos. */
      var code = form.getAttribute('data-bundle-discount');
      addToCart({ items: items }, form.querySelector('[type="submit"]')).then(function (res) {
        if (res && code) {
          window.location.href = ROUTES.root.replace(/\/$/, '') + '/discount/' +
            encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROUTES.root.replace(/\/$/, '') + '/cart');
        }
      });
      return;
    }

    var payload = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    var sellingPlan = data.get('selling_plan');
    if (sellingPlan) payload.items[0].selling_plan = sellingPlan;
    var button = form.querySelector('[type="submit"]');

    /* Bifele "Add to your order" stau in afara formularului de cumparare,
       deci nu apar in FormData. Fara pasul asta clientul bifa un produs si
       nu ajungea niciodata in cos. Le citim din coloana de produs. */
    var scope = form.closest('[data-product-form]') || document;
    var checked = scope.querySelectorAll('input[name="addon"]:checked');

    /* Broderia e tot un addon, dar cu un nume atasat. Numele merge ca line
       item property atat pe saltea cat si pe linia de broderie, ca sa apara
       pe comanda, pe bonul de livrare si in emailul de confirmare. */
    var monoName = '';
    var monoBox = scope.querySelector('[data-monogram-toggle]');
    if (monoBox && monoBox.checked) {
      var monoInput = scope.querySelector('[data-monogram-input]');
      monoName = cleanMonogram(monoInput ? monoInput.value : '', monoInput);
      if (!monoName) {
        showFormError(button, STRINGS.monogramMissing || 'Please type the name you would like embroidered.');
        if (monoInput) monoInput.focus();
        return;
      }
      properties[MONOGRAM_KEY] = monoName;
    }
    if (Object.keys(properties).length) payload.items[0].properties = properties;

    /* Marimea aleasa pentru saltea, ca sa adaugam protectia potrivita si nu
       prima varianta din lista. */
    var chosen = scope.querySelector('[data-variant-title]');
    var chosenTitle = chosen ? (chosen.getAttribute('data-variant-title') || '') : '';

    Array.prototype.forEach.call(checked, function (box) {
      if (!box.value) return;
      var id = box.value;
      var raw = box.getAttribute('data-addon-variants');
      if (raw && chosenTitle) {
        try {
          var map = JSON.parse(raw);
          if (map && map[chosenTitle]) id = String(map[chosenTitle]);
        } catch (e) { /* harta lipseste sau e stricata: ramanem pe varianta implicita */ }
      }
      var line = { id: id, quantity: 1 };
      if (box.hasAttribute('data-monogram-toggle') && monoName) {
        line.properties = {};
        line.properties[MONOGRAM_KEY] = monoName;
      }
      payload.items.push(line);
    });

    addToCart(payload, button);
  });

  function changeLine(key, quantity) {
    return fetch(ROUTES.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshCart(); });
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-change]');
    if (step) {
      var wrapper = step.closest('.quantity');
      var input = wrapper && wrapper.querySelector('[data-qty-input], input[type="number"]');
      if (!input) return;
      var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-change'), 10));
      input.value = next;
      if (step.hasAttribute('data-line-key')) changeLine(step.getAttribute('data-line-key'), next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.getAttribute('data-line-key'), 0); }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input][data-line-key]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ------------------------------------------------------------------ *
   * Variant selection
   * ------------------------------------------------------------------ */
  function initVariantForm(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        /* Daca un grup nu are nimic bifat, cadem pe prima optiune in loc de
           null - altfel niciun variant nu se potriveste si butonul moare. */
        if (checked) return checked.value;
        var first = group.querySelector('input');
        return first ? first.value : null;
      });
    }

    function matchVariant(options) {
      /* Produsele cu o singura varianta ("Default Title") nu randeaza
         selectoare de optiuni, deci options e []. Comparatia de mai jos ar
         da "Default Title" === undefined si butonul ar ramane Unavailable.
         Cand nu exista optiuni de ales, varianta e singura care exista. */
      if (!options.length || variants.length === 1) return variants[0];
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === options[index]; });
      });
    }

    function update() {
      var options = currentOptions();
      var variant = matchVariant(options);
      var idInput = root.querySelector('[data-variant-id]');
      var submit = root.querySelector('[data-add-button]');
      var priceHost = root.querySelector('[data-price-target]');

      root.querySelectorAll('[data-option-label-value]').forEach(function (el) {
        var index = parseInt(el.getAttribute('data-option-label-value'), 10);
        if (options[index]) el.textContent = options[index];
      });

      if (!variant) {
        if (submit) { submit.setAttribute('disabled', 'disabled'); submit.textContent = STRINGS.unavailable; }
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        /* Addonurile (protectie, topper) trebuie sa urmeze marimea aleasa.
           Tinem titlul variantei curente aici ca sa il poata citi handlerul
           de adaugare in cos. */
        idInput.setAttribute('data-variant-title', variant.title || '');
      }
      if (priceHost) {
        var html = '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceHost.innerHTML = html;
      }
      var caption = root.querySelector('[data-price-caption]');
      if (caption) caption.textContent = variant.options.join(' / ');
      if (submit) {
        if (variant.available) { submit.removeAttribute('disabled'); submit.textContent = STRINGS.addToCart; }
        else { submit.setAttribute('disabled', 'disabled'); submit.textContent = STRINGS.soldOut; }
      }
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: variant }, bubbles: true }));
    }

    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-index]')) update();
    });
    update();
  }

  /* ------------------------------------------------------------------ *
   * Media gallery
   * ------------------------------------------------------------------ */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    if (!main) return;
    var thumbs = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;

    function show(thumb) {
      var index = thumb.getAttribute('data-gallery-thumb');
      root.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        slide.hidden = slide.getAttribute('data-gallery-slide') !== index;
      });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      event.preventDefault();
      show(thumb);
    });

    /* Left and right walk the strip, so the gallery works without a mouse. */
    root.addEventListener('keydown', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var step = 0;
      if (event.key === 'ArrowRight') step = 1;
      else if (event.key === 'ArrowLeft') step = -1;
      else return;
      event.preventDefault();
      var next = thumbs[(thumbs.indexOf(thumb) + step + thumbs.length) % thumbs.length];
      next.focus();
      show(next);
    });

    /* A variant with its own image moves the gallery to it. */
    root.addEventListener('variant:changed', function (event) {
      var mediaId = event.detail && event.detail.variant && event.detail.variant.featured_media_id;
      if (!mediaId) return;
      var target = root.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
      if (target) show(target);
    });
  }

  /* ------------------------------------------------------------------ *
   * Facets — submit filter form without a full reload
   * ------------------------------------------------------------------ */
  function initFacets(form) {
    var busy = false;
    function apply() {
      if (busy) return;
      busy = true;
      var params = new URLSearchParams(new FormData(form)).toString();
      var url = form.getAttribute('action').split('?')[0] + (params ? '?' + params : '');
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-facets]', '[data-product-grid]', '[data-facet-toolbar]'].forEach(function (selector) {
            var fresh = doc.querySelector(selector);
            var current = document.querySelector(selector);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          window.history.replaceState({}, '', url);
        })
        .finally(function () { busy = false; });
    }
    document.addEventListener('change', function (event) {
      if (event.target.closest('[data-facets]') || event.target.closest('[data-sort]')) apply();
    });
    document.addEventListener('click', function (event) {
      var clear = event.target.closest('[data-facet-clear]');
      if (!clear) return;
      event.preventDefault();
      fetch(clear.getAttribute('href'), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-facets]', '[data-product-grid]', '[data-facet-toolbar]'].forEach(function (selector) {
            var fresh = doc.querySelector(selector);
            var current = document.querySelector(selector);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          window.history.replaceState({}, '', clear.getAttribute('href'));
        });
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); apply(); });
  }

  /* ------------------------------------------------------------------ *
   * Recently viewed (per browser, never leaves the device)
   * ------------------------------------------------------------------ */
  function recordRecentlyViewed(handle) {
    if (!handle) return;
    try {
      var stored = JSON.parse(window.localStorage.getItem('cadar:recent') || '[]');
      stored = stored.filter(function (item) { return item !== handle; });
      stored.unshift(handle);
      window.localStorage.setItem('cadar:recent', JSON.stringify(stored.slice(0, 8)));
    } catch (e) { /* private mode — nothing to do */ }
  }

  function renderRecentlyViewed(container) {
    var current = container.getAttribute('data-recently-viewed');
    var grid = container.querySelector('[data-recently-viewed-grid]');
    var handles;
    try { handles = JSON.parse(window.localStorage.getItem('cadar:recent') || '[]'); } catch (e) { handles = []; }
    handles = handles.filter(function (handle) { return handle && handle !== current; }).slice(0, 4);
    if (!handles.length || !grid) { container.hidden = true; return; }

    var root = ROUTES.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=product-card-render', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.filter(function (chunk) { return chunk && chunk.trim(); }).join('');
      if (!html) { container.hidden = true; return; }
      grid.innerHTML = html;
      container.hidden = false;
    });
  }

  function loadRecommendations(placeholder) {
    var url = placeholder.getAttribute('data-url');
    if (!url) return;
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('.section');
        if (!section) return;
        placeholder.replaceWith(section);
        boot(section);
      })
      .catch(function () { /* recommendations are optional — fail quietly */ });
  }

  /* ------------------------------------------------------------------ *
   * Mattress finder
   * Answers map to the same tags the collection facets use, so the result
   * is a real filtered URL rather than a guess. Runs entirely in the page.
   * ------------------------------------------------------------------ */
  function initFinder(section) {
    var configEl = section.querySelector('[data-finder-config]');
    var runEl = section.querySelector('[data-finder-run]');
    var previewEl = section.querySelector('[data-finder-preview]');
    var resultEl = section.querySelector('[data-finder-result]');
    var startBtn = section.querySelector('[data-finder-start]');
    if (!configEl || !runEl || !resultEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config.steps || !config.steps.length) return;

    var qEl = runEl.querySelector('[data-finder-question]');
    var optsEl = runEl.querySelector('[data-finder-options]');
    var countEl = runEl.querySelector('[data-finder-count]');
    var barEl = runEl.querySelector('[data-finder-bar]');
    var backBtn = runEl.querySelector('[data-finder-back]');
    var answers = [];
    var step = 0;

    function tagsFor(list) {
      /* One tag per group: Shopify ANDs tags, so two firmness values
         would return nothing. Later answers win. */
      var byGroup = {};
      var order = [];
      list.forEach(function (a) {
        (a.tags || []).forEach(function (t) {
          var group = t.split(':')[0];
          if (byGroup[group] === undefined) order.push(group);
          byGroup[group] = t;
        });
      });
      return order.map(function (g) { return byGroup[g]; });
    }

    function render() {
      var s = config.steps[step];
      qEl.textContent = s.q;
      countEl.textContent = (config.strings.count || '')
        .replace('{{ current }}', step + 1).replace('{{ total }}', config.steps.length);
      barEl.style.width = Math.round(((step) / config.steps.length) * 100) + '%';
      backBtn.hidden = step === 0;
      optsEl.innerHTML = '';
      s.options.forEach(function (opt, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'finder__option';
        b.textContent = opt.label;
        b.addEventListener('click', function () {
          answers[step] = opt;
          if (step < config.steps.length - 1) { step += 1; render(); }
          else finish();
        });
        optsEl.appendChild(b);
      });
      var first = optsEl.querySelector('button');
      if (first) first.focus();
    }

    function countAt(url) {
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return 0;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelectorAll('.card-grid .product-card').length;
        })
        .catch(function () { return -1; });
    }

    /* Shopify ANDs tags, so a specific combination can match nothing. Rather
       than sending someone to an empty page, drop the softest preference and
       try again — type first, then the shared-bed preference. */
    function narrowToSomething(tags) {
      var priority = ['type', 'feature', 'firmness', 'depth', 'size'];
      function attempt(list) {
        var url = config.base + (list.length ? '/' + list.join('+') : '');
        return countAt(url).then(function (n) {
          if (n !== 0 || !list.length) return { url: url, tags: list, count: n };
          for (var i = 0; i < priority.length; i++) {
            var group = priority[i];
            var idx = list.findIndex(function (t) { return t.split(':')[0] === group; });
            if (idx > -1) {
              var next = list.slice();
              next.splice(idx, 1);
              return attempt(next);
            }
          }
          return { url: config.base, tags: [], count: n };
        });
      }
      return attempt(tags);
    }

    function finish() {
      var wantsCustom = answers.some(function (a) { return a && a.custom; });
      var tags = tagsFor(answers.filter(Boolean));
      var link = resultEl.querySelector('[data-finder-link]');
      var href = wantsCustom ? config.customUrl : config.base + (tags.length ? '/' + tags.join('+') : '');
      link.href = href;
      link.textContent = wantsCustom ? config.strings.custom : config.strings.matches;
      if (!wantsCustom) {
        narrowToSomething(tags).then(function (best) {
          link.href = best.url;
          resultEl.querySelector('[data-finder-summary]').textContent =
            best.tags.length ? best.tags.map(prettyTag).join(' \u00b7 ') : config.strings.none;
          if (best.count > 0) {
            link.textContent = (config.strings.summary || config.strings.matches).replace('{{ count }}', best.count);
          }
        });
      }

      var reasons = answers.filter(Boolean)
        .map(function (a) { return a.why; })
        .filter(function (w) { return w; });
      resultEl.querySelector('[data-finder-summary]').textContent =
        wantsCustom ? qEl.textContent && config.strings.custom : (tags.length ? tags.map(prettyTag).join(' · ') : config.strings.none);
      resultEl.querySelector('[data-finder-reason]').textContent = reasons.join(' ');

      runEl.hidden = true;
      resultEl.hidden = false;
      barEl.style.width = '100%';
    }

    function prettyTag(t) {
      var v = t.split(':')[1] || t;
      v = v.replace(/-/g, ' ');
      return v.charAt(0).toUpperCase() + v.slice(1);
    }

    function start() {
      answers = [];
      step = 0;
      if (previewEl) previewEl.hidden = true;
      if (startBtn) startBtn.hidden = true;
      resultEl.hidden = true;
      runEl.hidden = false;
      render();
    }

    function reset() {
      answers = [];
      step = 0;
      resultEl.hidden = true;
      runEl.hidden = true;
      if (previewEl) previewEl.hidden = false;
      if (startBtn) { startBtn.hidden = false; startBtn.focus(); }
    }

    if (startBtn) startBtn.addEventListener('click', start);
    backBtn.addEventListener('click', function () { if (step > 0) { step -= 1; render(); } });
    section.querySelectorAll('[data-finder-reset]').forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', reset);
    });
  }

  /* Discount codes are applied by checkout, not by the cart, so the field
     hands the code over on the checkout URL. */
  function initCartDiscount(wrap) {
    var input = wrap.querySelector('[data-cart-discount-input]');
    var button = wrap.querySelector('[data-cart-discount-apply]');
    if (!input || !button) return;
    function go() {
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      window.location.href = ROUTES.root.replace(/\/$/, '') + '/checkout?discount=' + encodeURIComponent(code);
    }
    button.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }

  /* Time left until the courier cut-off. The delivery date itself is rendered
     server-side; this only counts down to the same deadline, so it can never
     promise a date the despatch cut-off cannot meet. No reset, no urgency
     theatre — at the cut-off it stops and says so. */
  function initDeliveryCountdown(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) return;

    function tick() {
      var now = new Date();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
      var ms = cutoff - now;
      if (ms <= 0) {
        el.textContent = STRINGS.deliveryCutoffPassed;
        return;
      }
      var mins = Math.floor(ms / 60000);
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      var left = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
      el.textContent = STRINGS.deliveryCutoff.replace('{{ time }}', left);
      setTimeout(tick, 30000);
    }
    tick();
  }

  /* Facade video. The iframe is created on the first press, so YouTube sets no
     cookie and loads no script for visitors who never watch. */
  function initVideoEmbed(button) {
    button.addEventListener('click', function () {
      var id = button.getAttribute('data-video-id');
      if (!id) return;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                  '?autoplay=1&rel=0&modestbranding=1';
      frame.title = button.getAttribute('aria-label') || 'Video';
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      frame.loading = 'lazy';
      frame.className = 'video-embed__frame';
      button.replaceWith(frame);
      frame.focus();
    }, { once: true });
  }

  /* ------------------------------------------------------------------ *
   * Boot
   * ------------------------------------------------------------------ */
  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-form]').forEach(initVariantForm);
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-facet-form]').forEach(initFacets);
    root.querySelectorAll('[data-recently-viewed]').forEach(renderRecentlyViewed);
    root.querySelectorAll('[data-product-recommendations]').forEach(loadRecommendations);
    root.querySelectorAll('[data-cart-discount]').forEach(initCartDiscount);
    root.querySelectorAll('[data-delivery-countdown]').forEach(initDeliveryCountdown);
    root.querySelectorAll('[data-video-embed]').forEach(initVideoEmbed);
    root.querySelectorAll('[data-finder-config]').forEach(function (el) { initFinder(el.closest('.shopify-section') || el.parentElement); });
    var pageHandle = document.body.getAttribute('data-product-handle');
    if (pageHandle) recordRecentlyViewed(pageHandle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
